import React from 'react';
import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useQuery, gql } from '@apollo/client';
import { portOfDataQry } from '../gql/PortOfDataQuery';
import { incoTermDataQry } from '../gql/incoTermDataQuery';
import { qualityGroupsDataQry } from '../gql/qualityGroupsDataQuery';
import { CurrenciesQry } from '../gql/CurrenciesQry';
import { ShippingLinesQry } from '../gql/ShippingLinesQry';
import { logisticMaterialsDataQry } from '../gql/logisticMaterialsDataQry';
import { useMutation, useApolloClient } from '@apollo/client';
import { CREATE_FRIGHTS } from '../graphqlDefs/freights/mutations';
import { getFreightsImporterSetting } from '../component/utils/freightsFrm';
import { volumeUnit } from './utils/volumeUnit';
import { QuantityUnitQry } from '../gql/QuantityUnitQry';
import { getMessage } from '../translations';
import { GET_LOGISTIC_FORWARDER } from '../graphqlDefs/freights/mutations';

const FreightAppFrm = () => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const handleGoBack = () => {
    navigate(-1); // Navigates back one step
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_FREIGHT_HAROLD_WEB_URL}`, '_blank');
  }
  const [result, setResult] = useState('');
  // State to define for fetching portOfLoading names from database
  const [portLoadingDropdownData, setPortLoadingDropdownData] = useState();
  const [portDestinationDropdownData, setPortDestinationDropdownData] =
    useState();
  const [placeDeliveriesDropdownData, setPlaceDeliveriesDropdownData] =
    useState();
  const [incoTermDropdownData, setIncoTermDropdownData] = useState();
  const [qualityGroupDropdownData, setQualityGroupDropdownData] = useState();
  const [shippingLinesDropdownData, setshippingLinesDropdownData] = useState();
  const [currenciesDropdownData, setCurrenciesDropdownData] = useState();
  const [currenciesAbbrDropdownData, setCurrenciesAbbrDropdownData] = useState();
  const [volumeUnitDropdownData, setVolumeUnitDropdownData] = useState();
  const [logisticMaterialsDropdownData, setLogisticMaterialsDropdownData] = useState([]);
  const [activeLoader, setActiveLoader] = useState(true);
  const [prioritizedValue, setPrioritizedValue] = useState(null);
  // Graphql query fetch port of loading & destination data
  const { data } = useQuery(portOfDataQry);
  const incoTermData = useQuery(incoTermDataQry);
  const qualityGroupData = useQuery(qualityGroupsDataQry);
  const currenciesData = useQuery(CurrenciesQry);
  const shippingLineData = useQuery(ShippingLinesQry);
  const quantityUnitData = useQuery(QuantityUnitQry);
  const logisticMaterialData = useQuery(logisticMaterialsDataQry);
  const filteredProvidersVariables = {
    filters: { type: "SHIPPING_LINE" },
    searchText: null,
  };
  const { loading: loading1, error: error1, data: data1, refetch: refetch1 } = useQuery(GET_LOGISTIC_FORWARDER, {
    variables: { input: filteredProvidersVariables },
  });
  
  const fetchData = () => {
    const portOfLoadingNames =
      data && data?.portOfLoadings
        ? data?.portOfLoadings?.map((portOfLoading) => ({
          label: portOfLoading?.value,
          alternativeMatches: [portOfLoading?.value],
          value: portOfLoading?.value,
          trackingCode: portOfLoading?.trackingCode,
          portName: portOfLoading?.value,
          type: 'string',
        }))
        : '>>';

    const portOfDestinationNames =
      data && data?.portOfDestinations
        ? data?.portOfDestinations?.map((portOfDestination) => ({
          label: portOfDestination?.value,
          alternativeMatches: [portOfDestination?.value],
          value: portOfDestination?.value,
          trackingCode: portOfDestination?.trackingCode,
          portName: portOfDestination?.value,
          type: 'string',
        }))
        : '>>';

    const placeOfDeliveryNames =
      data && data?.placesOfDelivery
        ? data?.placesOfDelivery?.map((placesOfDelvry) => ({
          label: placesOfDelvry?.value,
          alternativeMatches: [placesOfDelvry?.value],
          value: placesOfDelvry?.value,
          type: 'string',
        }))
        : '>>';

    const intoTermsNames =
      incoTermData.data && incoTermData.data?.incoterms
        ? incoTermData.data?.incoterms?.map((incoT) => ({
          label: incoT?.value,
          alternativeMatches: [incoT?.value],
          value: incoT?.value,
          type: 'string',
        }))
        : '>>';

    const qualityGroupNames =
      qualityGroupData.data && qualityGroupData.data?.qualityGroups
        ? qualityGroupData.data?.qualityGroups?.map((qualityG) => ({
          label: qualityG?.value,
          alternativeMatches: [qualityG?.value],
          value: qualityG?.value,
          type: 'string',
        }))
        : '>>';
    
    const logisticMaterialNames =
      logisticMaterialData.data && logisticMaterialData.data?.logisticMaterials
        ? logisticMaterialData.data?.logisticMaterials?.map((logistcM) => ({
          label: logistcM?.value,
          alternativeMatches: [logistcM?.value],
          value: logistcM?.value,
          type: 'string',
        }))
        : '>>';    

    const currenciesNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((Curren) => ({
          label: Curren?.shorthand,
          alternativeMatches: [Curren?.value],
          value: Curren?.value,
          type: 'string',
        }))
        : '>>';
    
    const currenciesAbbrNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((CurrenAbbr) => ({
          label: CurrenAbbr?.value,
          alternativeMatches: [CurrenAbbr?.value],
          value: CurrenAbbr?.value,
          type: 'string',
        }))
        : '>>';    
    
    const shippingLineNames =
      shippingLineData.data && shippingLineData.data?.shippingLines
        ? shippingLineData.data?.shippingLines?.map((ShippingLine) => ({
          label: ShippingLine?.value,
          alternativeMatches: [ShippingLine?.value],
          value: ShippingLine?.value,
          type: 'string',
        }))
        : '>>';     
    
    const quantityUnitNames =
      quantityUnitData.data && quantityUnitData.data?.quantityUnits
        ? quantityUnitData.data?.quantityUnits?.map((quantityUnit) => ({
          label: quantityUnit?.code,
          alternativeMatches: [quantityUnit?.code],
          value: quantityUnit?.code,
          type: 'string',
        }))
        : '>>';       
            
    const staticIncoTerms = [
      {
        label: "CFR",
        alternativeMatches: ["CFR"],
        value: "CFR",
        type: "string",
      },
      {
        label: "CIF",
        alternativeMatches: ["CIF"],
        value: "CIF",
        type: "string",
      },
    ];    
    // Update portOfLoading names to dropdown state
    setPortLoadingDropdownData(portOfLoadingNames);
    setPortDestinationDropdownData(portOfDestinationNames);
    setPlaceDeliveriesDropdownData(placeOfDeliveryNames);
    setIncoTermDropdownData(staticIncoTerms);
    setQualityGroupDropdownData(qualityGroupNames);
    // setshippingLinesDropdownData(shippingLineNames);
    setCurrenciesDropdownData(currenciesNames);
    setCurrenciesAbbrDropdownData(currenciesAbbrNames);
    setVolumeUnitDropdownData(quantityUnitNames);
    setLogisticMaterialsDropdownData(logisticMaterialNames);
  };
  
  function fetchFirstValidityDate(reqLastDt) {
    let retLastDt = '';
    const MAX_ALLOWED_VALUE = 10;
    if (reqLastDt !== '' && reqLastDt) {
      const inputDate = new Date(reqLastDt);
      inputDate.setDate(1);
      const firstDayOfMonth = new Date(inputDate);
      retLastDt = firstDayOfMonth.toISOString().slice(0, MAX_ALLOWED_VALUE);
    }
    return retLastDt;
  }

  const generateValidityDates = (monthNumber) => {
    const currentYear = new Date().getFullYear();
    const selectedMonth = monthNumber - 1; 
    // First day of the selected month
    const firstValidityDate = new Date(currentYear, selectedMonth, 1, 5, 30, 0); 
    const firstValidityDateString = `${firstValidityDate.getFullYear()}-${
      (firstValidityDate.getMonth() + 1).toString().padStart(2, '0')}-${
        firstValidityDate.getDate().toString().padStart(2, '0')}`;
  
    // Last day of the selected month
    const lastDay = new Date(currentYear, selectedMonth + 1, 0);
    const lastValidityDate = new Date(lastDay.getFullYear(), 
      lastDay.getMonth(), lastDay.getDate(), 5, 30, 0); 
    const lastValidityDateString = `${lastValidityDate.getFullYear()}-${
      (lastValidityDate.getMonth() + 1).toString().padStart(2, '0')}-${
        lastValidityDate.getDate().toString().padStart(2, '0')}`;
  
    return { firstValidityDate: firstValidityDateString, lastValidityDate: lastValidityDateString };
  };

  // Function to detect and extract currency code
  function extractCurrencyCode(cost) {
    // Regular expression to find the numeric part of the cost
    const costRegex = /^([\d.,]+)/;
    const currencyRegex = /([€$£¥₹Є]|USD|GBP|CAD|AUD|EUR|INR|JPY|CNY|SGD|CHF|HKD|SEK|KRW|NZD|RUB|ZAR)/i;
    // Ensure cost is treated as a string initially to capture currency
    const costString = cost.toString();
    const costMatch = costString.match(costRegex);
    const numericCost = costMatch ? costMatch[0].replace(/,/g, '') : null;
    const currencyMatch = costString.match(currencyRegex);
    const currencyCode = currencyMatch ? currencyMatch[0] : null;
    // Return cost and currency as an object
    return { cost: numericCost, currency: currencyCode };
  }

  function extractCostAndCurrency(costColumn) {
    let retProcessColumn = '';
    const costCurrencyColumn = [];
    if (costColumn !== '' && costColumn) {
      retProcessColumn = extractCurrencyCode(costColumn);
      costCurrencyColumn.push({
        extractedArr: retProcessColumn,
      });
    }
    return costCurrencyColumn;
  }
  // We are using this function for spliting the the rows by '/' for shipping line for ex. CMA/MARESK to two diff rows
  const splitStringBySlash = (inputString) => {
    if (typeof inputString !== 'string') {
      return []; // Handle non-string input
    }
  
    return inputString.split('/').map((substring) => substring.trim());
  };

  useEffect(() => {
    if (data !== undefined) {
      fetchData();
    }
  }, [data]);
  
  useEffect(() => {
    refetch1(); 
  }, [refetch1]);
  useEffect(() => {
    if (!loading1 && data1) {
      const shippingLineNames = data1.filteredProviders.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setshippingLinesDropdownData(shippingLineNames);      
    }
  }, [loading1, data1]);  

  // Fetch user unit from URL
  const { id } = useParams();
  const [logisticForwarder, validityMonth] = id.split('&');
  let logisticForwarderD = logisticForwarder;
  if(logisticForwarder === 'dashVal')
  {
    logisticForwarderD = '';
  }
  
  // Below function we are calling after submission and will push to database
  async function saveFrights(res) {  
    let flg = '';  
    if (res !== '' && res.length > 0) {
      const freightsValue = res.map((freight, index) => {
        return {
          comment: freight.comment === '' ? null : freight.comment,
          cost: freight.cost === '' ? null : parseFloat(freight.cost),
          costCurrency: freight.costCurrency === '' ? null : freight.costCurrency,
          costVolume: freight.costVolume === '' ? null : freight.costVolume,
          firstValidityDate: freight.firstValidityDate,
          incoterm: freight.incoterm === '' ? null : freight.incoterm,
          lastValidityDate: freight.lastValidityDate,
          logisticForwarder:
            freight.logisticForwarder === '' ? null : freight.logisticForwarder,
          logisticMaterial:
            freight.logisticMaterial === '' ? null : freight.logisticMaterial,
          portOfDestination:
            freight.portOfDestination === '' ? null : freight.portOfDestination,
          portOfLoading:
            freight.portOfLoading === '' ? null : freight.portOfLoading,
          qualityGroup: freight.qualityGroup === '' ? null : freight.qualityGroup,
          shippingLine: freight.shippingLine === '' ? null : freight.shippingLine,
          blCost: freight.blCost === '' ? null : freight.blCost,
          blCurrency: freight.blCurrency === '' || freight.blCurrency === null ? 
            freight.costCurrency : freight.blCurrency,
          thcAdminCost: freight.thcAdminCost === '' ? null : freight.thcAdminCost,
          thcAdminCostCurrency:
            freight.thcAdminCostCurrency === '' || freight.thcAdminCostCurrency === null
              ? freight.costCurrency
              : freight.thcAdminCostCurrency,
          customsCost: freight.customsCost === '' ? null : freight.customsCost,
          customsCurrency:
            freight.customsCurrency === '' || freight.customsCurrency === null
              ? freight.costCurrency
              : freight.customsCurrency,    
          thcAdminCostVolume:
            freight.thcAdminCostVolume === '' ? null : freight.thcAdminCostVolume,
          volumicCustomsCost: freight.volumicCustomsCost === '' ? null : freight.volumicCustomsCost,
          volumicCustomsCurrency:
            freight.volumicCustomsCurrency === '' || freight.volumicCustomsCurrency === null
              ? freight.costCurrency
              : freight.volumicCustomsCurrency,  
          volumicCustomsVolume:
          freight.volumicCustomsVolume === '' ? null : freight.volumicCustomsVolume,  
          demurrage: freight.demurrage === '' ? null : freight.demurrage,
          detention: freight.detention === '' ? null : freight.detention,
        };
      });
      try {
        const { data, error } = await client.mutate({
          mutation: CREATE_FRIGHTS,
          variables: { input: freightsValue },
        });
        return { flg: true, message: 'Success' };
        
      } catch (error) {
        return { flg: false, message: error };   
      }
    }
    return flg;
  }
  const importerSettings = getFreightsImporterSetting({
    portLoadingDropdownData,
    portDestinationDropdownData,
    incoTermDropdownData,
    qualityGroupDropdownData,
    currenciesDropdownData,
    currenciesAbbrDropdownData,
    shippingLinesDropdownData,
    volumeUnitDropdownData,
    logisticMaterialsDropdownData,
  });
  const handleImportResult = async (result, errors, complete, logs) => {
    if(errors.length === 0)
    {
      const rest = await saveFrights(result);
      if (rest.flg) {
        complete();
        setResult(result);
      } else {
        complete(new RejectSubmitResult('Error', rest.message));
        return false;
      }
    }
    else{
      complete(new RejectSubmitResult('Error', 'Please fill the required data.'));
      return false;
    }  
  };
  
  const handleDataListingOld = (modifier,excelData) => {
    // Access the Excel data
    const { data } = _.head(excelData);
    // Transform the data using map and flatMap
    const shippingLineHeaderVariations = ['shippingLine','shipping line','shipping Line','Shipping Line'];
    const shippingLineIndex = data[0].findIndex((header) =>
      shippingLineHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
    );
    const sanitizedData = data.flatMap((row, rowIndex) => {
      if (rowIndex === 0) {
        return [row]; // Preserve the header row
      } else {
        // Find the 'shippingLine' column dynamically in each row
        if (shippingLineIndex !== -1) {
          const shippingLine = row[shippingLineIndex];
          const shippingLinesArray = splitStringBySlash(shippingLine);
          return shippingLinesArray.map((line) => {
            const newRow = [...row];
            newRow[shippingLineIndex] = line;
            return newRow;
          });
        } else {
          return [row]; // If 'shippingLine' column is not found, keep the row as-is
        }
      }
    });
    return sanitizedData;    
  };  
  
  const handleDataListing = (modifier, excelData) => {
    try {
      const { data: excelRows } = _.head(excelData);
      const trackingCodeToPortMap = portLoadingDropdownData.reduce((acc, port) => {
        const trackingCode = port.trackingCode;
        if (trackingCode) {
          if (!acc[trackingCode]) {
            acc[trackingCode] = { ports: [], count: 0 };
          }
          acc[trackingCode].ports.push(port.portName);
          acc[trackingCode].count += 1;
        }
        return acc;
      }, {});
  
      const trackingCodeToDestinationMap = portDestinationDropdownData.reduce((acc, port) => {
        const trackingCode = port.trackingCode;
        if (trackingCode) {
          if (!acc[trackingCode]) {
            acc[trackingCode] = { ports: [], count: 0 };
          }
          acc[trackingCode].ports.push(port.portName);
          acc[trackingCode].count += 1;
        }
        return acc;
      }, {});
  
      const shippingLineHeaderVariations = ['shippingLine', 'shipping line', 'shipping Line', 'Shipping Line'];
      const trackingCodeHeaderVariations = ['POL', 'pol', 'Pol', 'PoL'];
      const destinationCodeHeaderVariations = ['POD', 'pod', 'Pod', 'PoD'];
  
      const t1ContainerHeaderVariations = ["20'ST", "20' ST", "20'st", "20 ST"];
      const t2ContainerHeaderVariations = ["40'ST", "40' ST", "40'st", "40 ST"];
      const t3ContainerHeaderVariations = ["40'HC", "40' HC", "40'hc", "40 HC"];
  
      const shippingLineIndex = excelRows[1].findIndex((header) =>
        shippingLineHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
      const trackingCodeIndex = excelRows[1].findIndex((header) =>
        trackingCodeHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
      const destinationCodeIndex = excelRows[1].findIndex((header) =>
        destinationCodeHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
      const t1ValueIndex = excelRows[1].findIndex((header) =>
        t1ContainerHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
      const t2ValueIndex = excelRows[1].findIndex((header) =>
        t2ContainerHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
      const t3ValueIndex = excelRows[1].findIndex((header) =>
        t3ContainerHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
      );
  
      const sanitizedData = excelRows.flatMap((row, rowIndex) => {
        if (rowIndex === 1) {
          return [row]; // Preserve the actual header row
        } else {
          const trackingCode = row[trackingCodeIndex];
          const destinationCode = row[destinationCodeIndex];
          const portData = trackingCodeToPortMap[trackingCode];
          const destinationData = trackingCodeToDestinationMap[destinationCode];
          const t1CValue = row[t1ValueIndex];
          const t2CValue = row[t2ValueIndex];
          const t3CValue = row[t3ValueIndex];
  
          if (!portData || !destinationData) {
            return [row]; // If there's no port data, return the row as is
          }
  
          const loadingPortCount = portData.count;
          const destinationPortCount = destinationData.count;
          const totalOccurrences = loadingPortCount * destinationPortCount;
  
          // Replicate rows based on the combination of loading and destination ports
          const replicatedRows = Array(totalOccurrences).fill().map((_, index) => {
            const newRow = [...row];
            newRow[trackingCodeIndex] = portData.ports[index % loadingPortCount];
            newRow[destinationCodeIndex] = 
            destinationData.ports[Math.floor(index / loadingPortCount) % destinationPortCount];
            return newRow;
          });
  
          // Now push the container values directly as strings
          const containerValues = [t1CValue, t2CValue, t3CValue].filter((val) => val !== null && val !== undefined);
  
          const finalRows = replicatedRows.flatMap((replicatedRow) => {
            return containerValues.map((value) => {
              const newRow = [...replicatedRow];
              newRow[8] = value; // Push each dynamic container value to newRow[8] as string
              return newRow;
            });
          });
  
          return finalRows;
        }
      });
  
      return sanitizedData;
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  return data === undefined ? (
    <div className={activeLoader === true ? 'bgl-clr loading' : 'bgl-clr loading'}>
      <div className='loaderText'>
        <p className=''>{getMessage('LOADING_TEXT')} </p>
        <span>
          <i></i>
          <i></i>
          <i></i>{' '}
        </span>
      </div>
    </div>
  ) : (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ?
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('Check out freights on web app')}
              </button>
              :
              <NuvoImporter
                licenseKey={licenseKey}
                settings={importerSettings}
                onResults={(result, errors, complete, logs) =>
                  handleImportResult(result, errors, complete, logs)
                }
                dataHandler={{
                  headerStep: (modifier, excelData) => handleDataListing(modifier, excelData), 
                }}
                onEntryInit={(row, rowIndex) => {
                  const { firstValidityDate, lastValidityDate } = generateValidityDates(validityMonth);
                  const blCurrency = row.blCost;
                  const costVolume = row.costVolume;
                  const incoterm = 'CFR';
                  const adminCost = row.thcAdminCost;
                  const volumicCutmCost = row.volumicCustomsCost;
                  const customsCostAndCurrency = row.customsCost;
                  const portOfLoading = row.portOfLoading;
                  let extractedCurrency = null;
                  let adminCostCurrency = null;
                  let volumicCustCostCurrency = null;
                  // let cost = 0;
                  let cost = row.cost;
                  let extractedAdminCost = 0;
                  let extractedVolumicCustCost = 0;
                  let extractedBlCost = 0;
                  let blCostCurrency = null;
                  let customsCost = 0;
                  let customsCurrency = null;
                  let sheetThcAdminCostVolume = row.thcAdminCostVolume;
                  let sheetVolumicCustomsVolume = row.volumicCustomsVolume;
                  let sheetCostVolume = row.costVolume;
                  let demurrage = row.demurrage;
                  let detention = row.detention;
                  let logisticMaterialValue = row.logisticMaterial
                  if (cost) {
                    const [blCostCurrency] = extractCostAndCurrency(cost) || [];
                    if (blCostCurrency) {
                      const extractedCost = parseFloat(blCostCurrency.extractedArr.cost); 
                      extractedCurrency = blCostCurrency.extractedArr.currency;
                      // Check if the extractedCost is a valid number
                      if (!isNaN(extractedCost)) {
                        cost = extractedCost;  // Only assign if valid number
                      } else {
                        throw new Error('Invalid cost value, not a valid number');
                      }
                    }
                  }
                  if (blCurrency) {
                    const [blCostsCurrency] = extractCostAndCurrency(row.blCost) || [];
                    if (blCostsCurrency) {
                      extractedBlCost = blCostsCurrency.extractedArr.cost;
                      blCostCurrency = blCostsCurrency.extractedArr.currency;
                    }   
                  }
                  if (adminCost) {
                    const [adminCostsCurrency] = extractCostAndCurrency(row.thcAdminCost) || [];
                    if (adminCostsCurrency) {
                      extractedAdminCost = adminCostsCurrency.extractedArr.cost;
                      adminCostCurrency = adminCostsCurrency.extractedArr.currency;
                    }   
                  }
                  if(volumicCutmCost) {
                    const [volumicCostsCurrency] = extractCostAndCurrency(row.volumicCustomsCost) || [];
                    if (volumicCostsCurrency) {
                      extractedVolumicCustCost = volumicCostsCurrency.extractedArr.cost;
                      volumicCustCostCurrency = volumicCostsCurrency.extractedArr.currency;
                    }  
                  }
                  if(customsCostAndCurrency){
                    const [customCostsCurrency] = extractCostAndCurrency(row.customsCost) || [];
                    if (customCostsCurrency) {
                      customsCost = customCostsCurrency.extractedArr.cost;
                      customsCurrency = customCostsCurrency.extractedArr.currency;
                    }
                  }
                  // if (row.cost) {
                  if (cost) {  
                    return {
                      logisticForwarder: {
                        value: logisticForwarderD,
                        info: [
                          {
                            message: 'Logistic forwarder',
                            level: 'info',
                          },
                        ],
                      },
                      logisticMaterial: {
                        value: logisticMaterialValue,
                        info: [
                          {
                            message: 'Cost to 40HC',
                            level: 'info',
                          },
                        ],
                      },
                      qualityGroup: {
                        value: 'Rubber',
                        info: [
                          {
                            message: 'Quality group',
                            level: 'info',
                          },
                        ],
                      },
                      firstValidityDate: {
                        value: firstValidityDate,
                        info: [
                          {
                            message: 'First validity date',
                            level: 'info',
                          },
                        ],
                      },
                      lastValidityDate: {
                        value: lastValidityDate,
                        info: [
                          {
                            message: 'Last validity date',
                            level: 'info',
                          },
                        ],
                      },
                      cost: {
                        value: cost,
                        info: [
                          {
                            message: 'Cost',
                            level: 'info',
                          },
                        ],
                      },
                      costVolume: {
                        value: sheetCostVolume === '' || sheetCostVolume === undefined ? 'Ctn' : sheetCostVolume,
                        info: [
                          {
                            message: 'CTC',
                            level: 'info',
                          },
                        ],
                      },
                      costCurrency: {
                        value: extractedCurrency,
                        info: [
                          {
                            message: 'Cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      blCost: {
                        value: extractedBlCost === 0 ? cost : extractedBlCost,
                        info: [
                          {
                            message: 'Bl cost',
                            level: 'info',
                          },
                        ],
                      },
                      blCurrency: {
                        value: blCostCurrency === null ? extractedCurrency : blCostCurrency,
                        info: [
                          {
                            message: 'Bl cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCost: {
                        value: extractedAdminCost === 0 ? cost : extractedAdminCost,
                        info: [
                          {
                            message: 'Admin cost',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCostVolume: {
                        value: sheetThcAdminCostVolume === '' ? 'Ctn' : sheetThcAdminCostVolume,
                        info: [
                          {
                            message: 'Admin cost volume',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCostCurrency: {
                        value: adminCostCurrency === null ? extractedCurrency : adminCostCurrency,
                        info: [
                          {
                            message: 'Admin cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      customsCost: {
                        value: customsCost === 0 ? cost : customsCost,
                        info: [
                          {
                            message: 'Customs cost',
                            level: 'info',
                          },
                        ],
                      },
                      customsCurrency: {
                        value: customsCurrency === null ? extractedCurrency : customsCurrency,
                        info: [
                          {
                            message: 'Customs cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      incoterm: {
                        value: 'CFR',
                        info: [
                          {
                            message: 'Incoterms',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsCost: {
                        value: extractedVolumicCustCost === 0 ? cost : extractedVolumicCustCost,
                        info: [
                          {
                            message: 'Volumic customs cost',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsVolume: {
                        value: sheetVolumicCustomsVolume === '' ? 'Ctn' : sheetVolumicCustomsVolume,
                        info: [
                          {
                            message: 'Volumic customs volume',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsCurrency: {
                        value: volumicCustCostCurrency === null ? extractedCurrency : volumicCustCostCurrency,
                        info: [
                          {
                            message: 'Volumic customs currency',
                            level: 'info',
                          },
                        ],
                      },
                      demurrage: {
                        value: demurrage,
                        info: [
                          {
                            message: 'Demurrage in days',
                            level: 'info',
                          },
                        ],
                      },
                      detention: {
                        value: detention,
                        info: [
                          {
                            message: 'Detention in days',
                            level: 'info',
                          },
                        ],
                      },
                    };
                  }
                }}              
                
              >
                {getMessage('Import Freight')}
              </NuvoImporter>
            }  
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          {result !== '' ?
            <div className='white-box'>
              {Object.keys(result).length !== 0 && (
                <pre>
                  {typeof result === 'string'
                    ? result
                    : JSON.stringify(result, null, 2)}
                </pre>
              )}
            </div>
            :
            <></>
          }
        </div>
      </div>
    </div>
  );
};
export default FreightAppFrm;
